(function() {
  var PLUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10" style="display:block;width:14px;height:14px"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>';
  function injectBoost(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".boost-sd__button--square:not([data-plus])").forEach(function(btn) {
      btn.innerHTML = PLUS_SVG;
      btn.setAttribute("data-plus", "1");
    });
  }
  function injectAll(root) {
    injectBoost(root);
  }
  document.addEventListener("DOMContentLoaded", function() {
    injectAll(document);
  });
  var queued = false;
  var observer = new MutationObserver(function(mutations) {
    if (queued) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(".boost-sd__button--square") || n.firstElementChild && n.querySelector(".boost-sd__button--square:not([data-plus])")) {
          queued = true;
          requestAnimationFrame(function() {
            queued = false;
            injectAll(document);
          });
          return;
        }
      }
    }
  });
  document.addEventListener("DOMContentLoaded", function() {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

(function() {
  "use strict";
  var _me = document.currentScript || document.querySelector("script[data-wl-js]");
  var WL_JS = _me ? _me.getAttribute("data-wl-js") : "";
  var WL_CSS = _me ? _me.getAttribute("data-wl-css") : "";
  function ensureWishlistAssets() {
    if (WL_JS && !document.querySelector('script[src*="wishlist.js"]')) {
      var s = document.createElement("script");
      s.src = WL_JS;
      s.defer = true;
      document.head.appendChild(s);
    }
    if (WL_CSS && !document.querySelector('link[href*="wishlist.css"]')) {
      var l = document.createElement("link");
      l.rel = "stylesheet";
      l.href = WL_CSS;
      document.head.appendChild(l);
    }
  }
  var _nearIO = null;
  var _nearCbs = typeof WeakMap === "function" ? new WeakMap : null;
  function whenNear(el, fn) {
    if (!("IntersectionObserver" in window) || !_nearCbs) {
      fn();
      return;
    }
    if (!_nearIO) {
      _nearIO = new IntersectionObserver(function(entries) {
        entries.forEach(function(en) {
          if (!en.isIntersecting) return;
          _nearIO.unobserve(en.target);
          var cb = _nearCbs.get(en.target);
          _nearCbs.delete(en.target);
          if (cb) cb();
        });
      }, {
        rootMargin: "600px"
      });
    }
    _nearCbs.set(el, fn);
    _nearIO.observe(el);
  }
  var _pcache = {};
  function fetchProduct(handle, cb) {
    if (_pcache[handle]) {
      cb(_pcache[handle]);
      return;
    }
    fetch("/products/" + handle + ".js").then(function(r) {
      return r.json();
    }).then(function(p) {
      var imgs = (p.images || []).slice(0, 3).map(function(img) {
        return typeof img === "string" ? img : img.src || "";
      });
      _pcache[handle] = {
        id: String(p.id),
        variantId: String(p.variants && p.variants[0] ? p.variants[0].id : ""),
        image: imgs[0] || "",
        price: p.variants && p.variants[0] ? String(p.variants[0].price / 100) : "",
        images: imgs,
        tags: p.tags || []
      };
      cb(_pcache[handle]);
    }).catch(function() {
      cb(null);
    });
  }
  function syncWishlist() {
    var list = [];
    try {
      list = JSON.parse(localStorage.getItem("halamama_wishlist")) || [];
    } catch (e) {}
    document.querySelectorAll("[data-wl-btn]").forEach(function(btn) {
      var id = btn.getAttribute("data-product-id");
      var active = !!id && list.some(function(p) {
        return String(p.id) === id;
      });
      btn.classList.toggle("wl-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.setAttribute("aria-label", active ? "Remove from Wishlist" : "Add to Wishlist");
    });
  }
  function fixPriceSaving(root) {
    (root || document).querySelectorAll(".boost-sd__product-price-content--column:not([data-ps-fixed])").forEach(function(wrapper) {
      wrapper.setAttribute("data-ps-fixed", "1");
      var saving = wrapper.querySelector(".boost-sd__product-price--saving");
      var compareDiv = wrapper.querySelector(".boost-sd__product-price--compare");
      if (!saving || !compareDiv) return;
      if (!compareDiv.contains(saving)) compareDiv.appendChild(saving);
      var compareText = compareDiv.querySelector(".boost-sd__format-currency--price-compare");
      if (compareText) {
        compareText.style.textDecoration = "line-through";
        compareText.style.color = "#8a8a8a";
        compareText.style.fontSize = "13px";
        compareText.style.fontWeight = "500";
        compareText.style.marginRight = "5px";
      }
      saving.style.color = "#d11212";
      saving.style.fontSize = "13px";
      saving.style.fontWeight = "700";
    });
  }
  function buildWishlistBtn(card, handle) {
    var linkImage = card.querySelector(".boost-sd__product-link-image");
    if (!linkImage) return;
    var posDiv = linkImage.firstElementChild;
    if (!posDiv || posDiv.querySelector("[data-wl-btn]")) return;
    var title = "";
    var titleEl = card.querySelector(".boost-sd__product-title");
    if (titleEl) title = titleEl.textContent.trim();
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "wl-heart-btn";
    btn.setAttribute("data-wl-btn", "");
    btn.setAttribute("data-no-redirect", "true");
    btn.setAttribute("data-handle", handle);
    btn.setAttribute("data-title", title);
    btn.setAttribute("data-product-id", "");
    btn.setAttribute("data-variant-id", "");
    btn.setAttribute("data-image", "");
    btn.setAttribute("data-price", "");
    btn.setAttribute("data-variant-title", "");
    btn.setAttribute("aria-label", "Add to Wishlist");
    btn.setAttribute("aria-pressed", "false");
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" ' + 'stroke-width="0" width="16" height="16" aria-hidden="true">' + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06' + "a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06" + 'a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    btn.style.top = "6px";
    btn.style.left = "8px";
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var pid = btn.getAttribute("data-product-id");
      if (!pid) return;
      var KEY = "halamama_wishlist";
      var list = [];
      try {
        list = JSON.parse(localStorage.getItem(KEY)) || [];
      } catch (err) {}
      var found = false;
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(pid)) {
          list.splice(i, 1);
          found = true;
          break;
        }
      }
      if (!found) {
        list.push({
          id: pid,
          handle: btn.getAttribute("data-handle") || "",
          title: btn.getAttribute("data-title") || "",
          image: btn.getAttribute("data-image") || "",
          price: btn.getAttribute("data-price") || "",
          variantId: btn.getAttribute("data-variant-id") || "",
          variantTitle: btn.getAttribute("data-variant-title") || ""
        });
      }
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (err) {}
      syncWishlist();
      document.querySelectorAll(".wl-count-badge").forEach(function(el) {
        el.textContent = list.length;
        el.style.display = list.length > 0 ? "flex" : "none";
      });
      try {
        var bc = new BroadcastChannel("halamama_wl_sync");
        bc.postMessage("sync");
        bc.close();
      } catch (err) {}
      btn.classList.add("wl-pop");
      btn.addEventListener("animationend", function() {
        btn.classList.remove("wl-pop");
      }, {
        once: true
      });
    });
    posDiv.appendChild(btn);
    whenNear(card, function() {
      fetchProduct(handle, function(data) {
        if (!data) return;
        btn.setAttribute("data-product-id", data.id);
        btn.setAttribute("data-variant-id", data.variantId);
        btn.setAttribute("data-image", data.image);
        btn.setAttribute("data-price", data.price);
        syncWishlist();
        buildImageSlider(card, data.images);
        if (!(window.pocoProductLabels && window.pocoProductLabels.length)) buildProductLabels(card, data);
      });
    });
  }
  function buildRatingBadge(card) {
    var linkImage = card.querySelector(".boost-sd__product-link-image");
    if (!linkImage) return;
    var posDiv = linkImage.firstElementChild;
    if (!posDiv || posDiv.querySelector(".boost-sd__rating-badge")) return;
    var jdgmPrev = card.querySelector(".jdgm-prev-badge[data-average-rating]");
    if (!jdgmPrev) return;
    var avg = jdgmPrev.getAttribute("data-average-rating");
    var count = jdgmPrev.getAttribute("data-number-of-reviews");
    if (!avg || parseFloat(avg) <= 0 || parseInt(count || "0", 10) <= 0) return;
    var badge = document.createElement("div");
    badge.className = "boost-sd__rating-badge";
    badge.style.cssText = "position:absolute;top:auto;right:6px;left:auto;bottom:4px;" + "z-index:10;display:inline-flex;align-items:center;gap:4px;" + "padding:3px 8px;background:#fff;border-radius:999px;" + "box-shadow:0 1px 3px rgba(0,0,0,0.08);font-size:12px;" + "font-weight:600;color:#111;line-height:1;pointer-events:none;";
    badge.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ' + 'width="12" height="12" style="fill:#f5b400;flex-shrink:0;display:block" aria-hidden="true">' + '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 ' + '17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' + '<span style="font-size:12px;font-weight:600;color:#111">' + parseFloat(avg).toFixed(1) + "</span>" + '<span style="font-size:11px;color:#888;font-weight:500">(' + count + ")</span>";
    posDiv.appendChild(badge);
  }
  function buildImageSlider(card, images) {
    if (!images || images.length < 2) return;
    var linkImage = card.querySelector(".boost-sd__product-link-image");
    if (!linkImage) return;
    var posDiv = linkImage.firstElementChild;
    if (!posDiv || posDiv.querySelector(".bcard-dots")) return;
    var imageWrapper = posDiv.querySelector(".boost-sd__product-image-wrapper");
    if (!imageWrapper) return;
    var anchor = imageWrapper.querySelector("a.boost-sd__product-link");
    var href = anchor ? anchor.getAttribute("href") : "#";
    imageWrapper.style.position = "relative";
    imageWrapper.style.overflow = "hidden";
    var rail = document.createElement("div");
    rail.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;";
    var track = document.createElement("div");
    track.style.cssText = "display:flex;direction:ltr;height:100%;transition:transform 0.35s ease;will-change:transform;";
    var lazyImgs = [];
    images.forEach(function(src, si) {
      var slide = document.createElement("a");
      slide.href = href;
      slide.style.cssText = "flex:0 0 100%;min-width:100%;display:block;height:100%;overflow:hidden;";
      var img = document.createElement("img");
      if (si === 0) {
        img.src = src;
        img.setAttribute("loading", "lazy");
      } else {
        img.setAttribute("data-src", src);
        lazyImgs.push(img);
      }
      img.alt = "";
      img.style.cssText = "width:100%;height:100%;object-fit:cover;display:block;";
      slide.appendChild(img);
      track.appendChild(slide);
    });
    rail.appendChild(track);
    function makeArrow(dir) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("data-no-redirect", "true");
      b.setAttribute("aria-label", dir === "prev" ? "Previous image" : "Next image");
      b.innerHTML = dir === "prev" ? '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>' : '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>';
      b.style.cssText = "position:absolute;top:50%;transform:translateY(-50%);z-index:8;" + (dir === "prev" ? "left:8px;" : "right:8px;") + "width:26px;height:26px;border:none;border-radius:50%;" + "background:rgba(255,255,255,0.88);color:#333;cursor:pointer;" + "display:none;align-items:center;justify-content:center;padding:0;" + "box-shadow:0 1px 4px rgba(0,0,0,0.18);";
      return b;
    }
    var prevArrow = makeArrow("prev");
    var nextArrow = makeArrow("next");
    if (window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      imageWrapper.addEventListener("mouseenter", function() {
        prevArrow.style.display = "flex";
        nextArrow.style.display = "flex";
      });
      imageWrapper.addEventListener("mouseleave", function() {
        prevArrow.style.display = "none";
        nextArrow.style.display = "none";
      });
    }
    var dotsWrap = document.createElement("div");
    dotsWrap.className = "bcard-dots";
    dotsWrap.style.cssText = "position:absolute;bottom:28px;left:0;right:0;height:12px;" + "display:flex;align-items:center;justify-content:center;gap:5px;z-index:8;pointer-events:none;";
    var dotEls = images.map(function(_, i) {
      var d = document.createElement("span");
      d.style.cssText = "width:5px;height:5px;border-radius:50%;cursor:pointer;flex-shrink:0;" + "transition:background 0.2s;background:" + (i === 0 ? "#555" : "rgba(0,0,0,0.22)") + ";";
      d.setAttribute("data-no-redirect", "true");
      d.style.pointerEvents = "auto";
      return d;
    });
    dotEls.forEach(function(d) {
      dotsWrap.appendChild(d);
    });
    var current = 0;
    var total = images.length;
    function loadRest() {
      while (lazyImgs.length) {
        var li = lazyImgs.shift();
        li.src = li.getAttribute("data-src");
        li.removeAttribute("data-src");
      }
    }
    function goTo(idx) {
      loadRest();
      if (idx >= total) idx = 0;
      if (idx < 0) idx = total - 1;
      current = idx;
      track.style.transform = "translateX(-" + current * 100 + "%)";
      dotEls.forEach(function(d, i) {
        d.style.background = i === current ? "#555" : "rgba(0,0,0,0.22)";
      });
    }
    function guardClick(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    prevArrow.addEventListener("click", function(e) {
      guardClick(e);
      goTo(current - 1);
    });
    nextArrow.addEventListener("click", function(e) {
      guardClick(e);
      goTo(current + 1);
    });
    dotEls.forEach(function(d, i) {
      d.addEventListener("click", function(e) {
        guardClick(e);
        goTo(i);
      });
    });
    var _tx0 = 0;
    imageWrapper.addEventListener("touchstart", function(e) {
      loadRest();
      _tx0 = e.changedTouches[0].clientX;
    }, {
      passive: true
    });
    imageWrapper.addEventListener("touchend", function(e) {
      var dx = e.changedTouches[0].clientX - _tx0;
      if (dx > 45) goTo(current - 1); else if (dx < -45) goTo(current + 1);
    }, {
      passive: true
    });
    imageWrapper.innerHTML = "";
    imageWrapper.appendChild(rail);
    imageWrapper.appendChild(prevArrow);
    imageWrapper.appendChild(nextArrow);
    posDiv.appendChild(dotsWrap);
    placeAllDots();
    setTimeout(placeAllDots, 1200);
  }
  var _labelCfg = null;
  function getLabelCfg() {
    if (_labelCfg !== null) return _labelCfg;
    var el = document.getElementById("bcard-labels-cfg");
    try {
      _labelCfg = el ? JSON.parse(el.textContent) : [];
    } catch (e) {
      _labelCfg = [];
    }
    return _labelCfg;
  }
  function isLabelActive(lbl) {
    var now = new Date;
    now.setHours(0, 0, 0, 0);
    if (lbl.startDate) {
      var s = new Date(lbl.startDate);
      if (!isNaN(s.getTime()) && now < s) return false;
    }
    if (lbl.endDate) {
      var e = new Date(lbl.endDate);
      if (!isNaN(e.getTime()) && now > e) return false;
    }
    return true;
  }
  function labelMatchesProduct(lbl, data) {
    if (lbl.filterType === "all") return true;
    if (lbl.filterType === "tag") {
      var v = (lbl.filterVal || "").toLowerCase().trim();
      return v && (data.tags || []).some(function(t) {
        return t.toLowerCase().trim() === v;
      });
    }
    if (lbl.filterType === "collection") {
      var v = (lbl.filterVal || "").toLowerCase().trim();
      var m = window.location.pathname.match(/\/collections\/([^?#\/]+)/);
      return v && m ? m[1].toLowerCase() === v : false;
    }
    return false;
  }
  function buildProductLabels(card, data) {
    var linkImage = card.querySelector(".boost-sd__product-link-image");
    if (!linkImage) return;
    var posDiv = linkImage.firstElementChild;
    if (!posDiv) return;
    var labels = getLabelCfg();
    var isMob = window.innerWidth < 768;
    var isAr = (document.documentElement.lang || "").toLowerCase().indexOf("ar") === 0 || document.documentElement.dir === "rtl";
    labels.forEach(function(lbl, idx) {
      if (!lbl.text || !isLabelActive(lbl) || !labelMatchesProduct(lbl, data)) return;
      if (posDiv.querySelector('[data-bcard-label="' + idx + '"]')) return;
      var el = document.createElement("div");
      el.setAttribute("data-bcard-label", String(idx));
      el.setAttribute("data-no-redirect", "true");
      el.textContent = isAr && lbl.textAr ? lbl.textAr : lbl.text;
      var pos = lbl.position || "bottom-left";
      var posStyle = pos === "bottom-left" ? "bottom:0;left:0;" : pos === "bottom-right" ? "bottom:0;right:0;" : pos === "top-left" ? "top:0;left:0;" : "top:0;right:0;";
      var w = isMob ? lbl.wMob : lbl.wDesk;
      var wStyle = w && w > 0 ? "width:" + w + "px;text-align:center;" : "";
      el.style.cssText = "position:absolute;" + posStyle + wStyle + "background:" + (lbl.bg || "#000") + ";" + "color:" + (lbl.color || "#fff") + ";" + "font-size:" + (lbl.fontSize || 11) + "px;" + "font-weight:700;letter-spacing:0.04em;" + "padding:" + (lbl.padding || "2px 8px") + ";" + "border-radius:" + (lbl.radius || "3px") + ";" + "z-index:7;pointer-events:none;line-height:1.3;white-space:nowrap;";
      posDiv.appendChild(el);
    });
  }
  function enhanceBoostCards(root) {
    var r = root && root.querySelectorAll ? root : document;
    fixPriceSaving(r);
    setTimeout(placeAllDots, 300);
    setTimeout(placeAllDots, 1500);
    r.querySelectorAll(".boost-sd__product-item:not([data-bv5])").forEach(function(card) {
      card.setAttribute("data-bv5", "1");
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = (link.getAttribute("href") || "").match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var handle = m[1];
      var linkImage = card.querySelector(".boost-sd__product-link-image");
      if (linkImage && linkImage.firstElementChild) {
        linkImage.firstElementChild.style.paddingTop = "32px";
        linkImage.firstElementChild.style.paddingBottom = "20px";
      }
      buildWishlistBtn(card, handle);
      buildRatingBadge(card);
    });
  }
  function placeCardDots(item) {
    var dots = item.querySelector(".bcard-dots") || item.querySelector(".boost-sd__img-dots");
    var media = item.querySelector(".boost-sd__product-image-wrapper");
    if (!dots || !media) return;
    var host = dots.offsetParent;
    if (!host) return;
    var hr = host.getBoundingClientRect();
    var mr = media.getBoundingClientRect();
    if (!hr.height || !mr.height) return;
    var limit = mr.bottom - 8;
    var scope = item.querySelector(".boost-sd__product-link-image") || item;
    var nodes = scope.querySelectorAll("*");
    for (var k = 0; k < nodes.length; k++) {
      var n = nodes[k];
      if (n === dots || dots.contains(n) || n.closest(".boost-sd__img-arrows, .boost-sd__img-slider, button")) continue;
      var cs = getComputedStyle(n);
      if (cs.position !== "absolute" || cs.display === "none" || cs.visibility === "hidden") continue;
      var r = n.getBoundingClientRect();
      if (!r.height || r.height > mr.height * 0.4 || r.width >= mr.width && r.height >= mr.height) continue;
      if (r.bottom < mr.bottom - 4 || r.top > mr.bottom) continue;
      if (r.top - 6 < limit) limit = r.top - 6;
    }
    dots.style.setProperty("left", "0", "important");
    dots.style.setProperty("right", "0", "important");
    dots.style.setProperty("transform", "none", "important");
    dots.style.setProperty("justify-content", "center", "important");
    dots.style.setProperty("top", "auto", "important");
    dots.style.setProperty("bottom", Math.max(0, Math.round(hr.bottom - limit)) + "px", "important");
  }
  function boostHasTop(item) {
    var labs = item.querySelectorAll(".poco-blabel:not(.pcard-label--above):not(.poco-bghost)");
    for (var i = 0; i < labs.length; i++) {
      if (!labs[i].hidden && labs[i].style.top === "0px") return true;
    }
    return false;
  }
  function compactBoostTop() {
    var items = document.querySelectorAll(".boost-sd__product-item");
    var groups = new Map();
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.offsetParent) continue;
      var li = it.querySelector(".boost-sd__product-link-image");
      var pos = li && li.firstElementChild;
      if (!pos) continue;
      var grid = it.parentElement;
      var key = Math.round((it.getBoundingClientRect().top + window.pageYOffset) / 4);
      var g = groups.get(grid);
      if (!g) { g = {}; groups.set(grid, g); }
      (g[key] = g[key] || []).push({ it: it, pos: pos });
    }
    groups.forEach(function(rows) {
      Object.keys(rows).forEach(function(k) {
        var row = rows[k];
        var keep = row.some(function(x) { return boostHasTop(x.it); });
        row.forEach(function(x) {
          var want = keep ? "32px" : "0px";
          if (x.pos.style.paddingTop !== want) x.pos.style.paddingTop = want;
        });
      });
    });
  }
  var _dotsRaf = 0;
  function placeAllDots() {
    if (_dotsRaf) return;
    _dotsRaf = requestAnimationFrame(function() {
      _dotsRaf = 0;
      compactBoostTop();
      document.querySelectorAll(".boost-sd__product-item").forEach(placeCardDots);
    });
  }
  window.addEventListener("resize", placeAllDots);
  window.addEventListener("load", placeAllDots);
  document.addEventListener("mouseover", function(e) {
    var it = e.target.closest && e.target.closest(".boost-sd__product-item");
    if (it && !it.__dotsHover) {
      it.__dotsHover = true;
      placeCardDots(it);
      it.addEventListener("mouseleave", function() { it.__dotsHover = false; }, { once: true });
    }
  }, { passive: true });
  document.addEventListener("DOMContentLoaded", function() {
    ensureWishlistAssets();
    enhanceBoostCards(document);
    [ 400, 1e3, 2500 ].forEach(function(ms) {
      setTimeout(function() {
        enhanceBoostCards(document);
      }, ms);
    });
  });
  [ "boost-sd:finish", "boost-sd:view-loaded", "boost-sd:instant-search:after", "boost-sd:filter:after", "boost-sd:sort:after", "boost-sd:page:after" ].forEach(function(evt) {
    document.addEventListener(evt, function() {
      setTimeout(function() {
        enhanceBoostCards(document);
      }, 80);
    });
  });
  var _eObs = new MutationObserver(function(mutations) {
    var found = false;
    for (var i = 0; i < mutations.length && !found; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.classList.contains("boost-sd__product-item") || n.firstElementChild && n.querySelector(".boost-sd__product-item")) {
          found = true;
          break;
        }
      }
    }
    if (found) {
      clearTimeout(window.__BENH_T);
      window.__BENH_T = setTimeout(function() {
        enhanceBoostCards(document);
      }, 120);
    }
  });
  document.addEventListener("DOMContentLoaded", function() {
    _eObs.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
